// SXAlert.tsx
import { JSX, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { SXButton } from "@common/components/ui-components/SXButton";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface SXAlertProps {
  id: string;
  status: number | string | JSX.Element;
  text: string | JSX.Element;
  context?: string;
  varient?: string;
  keep?: boolean;
  onClose: () => void; // dispatch removeAlert
}

export const SXAlert = (props: SXAlertProps) => {
  const [opacity, setOpacity] = useState<number>(20);

  useEffect(() => {
    if (props.keep) return;

    if (opacity > 0) {
      const timer = setTimeout(() => {
        setOpacity(opacity - 0.3);
      }, 108);

      return () => clearTimeout(timer);
    }

    if (opacity <= 0) {
      props.onClose();
    }
  }, [opacity]);

  return (
    // Positioning and width are the stack's job (SXAlertsContainer) - this used to place itself with
    // a fixed per-index percentage offset from the bottom of the viewport and no width limit, which
    // let a long message run the full width of the screen and let two of them overlap.
    <Alert
      style={{
        opacity: opacity,
        margin: 0,
        // The stack disables pointer events so it does not swallow clicks over the page; the alerts
        // themselves have to take them back, or the close button would be dead.
        pointerEvents: "auto",
      }}
      variant={props.varient}
      id={props.id}
      className="sxalert no-print"
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
        {/* Wraps over as many rows as the message needs, rather than forcing the alert wider. */}
        <div style={{ minWidth: 0, overflowWrap: "anywhere" }}>
          {props.context ? (
            <>
              <strong>{props.status}:</strong> ({props.context}) {props.text}
            </>
          ) : (
            <>
              <strong>{props.status}:</strong> {props.text}
            </>
          )}
        </div>
        <div style={{ flex: "0 0 auto" }}>
          <SXButton onClick={props.onClose} icon={faTimes} />
        </div>
      </div>
    </Alert>
  );
};
